import { UserRolesEnum } from "@/providers/store/api/auth/auth.enum";

/** Platform roles for data access and district role checks. */
export const DATA_ACCESS_PLATFORM_ROLES: UserRolesEnum[] = [
  UserRolesEnum.SUPER_ADMIN,
  UserRolesEnum.PLATFORM_ADMIN,
];

export const PLATFORM_ROLES: UserRolesEnum[] = [
  UserRolesEnum.SUPER_ADMIN,
  UserRolesEnum.PLATFORM_ADMIN,
];

/** District roles allowed for /panel/data access. */
export const DATA_ACCESS_DISTRICT_ROLES = [
  UserRolesEnum.DISTRICT_ADMIN,
  UserRolesEnum.DISTRICT_STANDARD_USER,
] as const;

/** Roles allowed to see the Files section (excludes Limited SD / DISTRICT_LIMITED_USER). */
export const ROLES_CAN_SEE_FILES: UserRolesEnum[] = [
  UserRolesEnum.SUPER_ADMIN,
  UserRolesEnum.PLATFORM_ADMIN,
  UserRolesEnum.DISTRICT_ADMIN,
  UserRolesEnum.DISTRICT_STANDARD_USER,
];

/** Roles allowed to see the User Management section (excludes DISTRICT_LIMITED_USER). */
export const ROLES_CAN_SEE_USER_MANAGEMENT: UserRolesEnum[] = [
  UserRolesEnum.SUPER_ADMIN,
  UserRolesEnum.PLATFORM_ADMIN,
  UserRolesEnum.DISTRICT_ADMIN,
  UserRolesEnum.DISTRICT_STANDARD_USER,
];

/** Roles allowed to see the My District section (read path); excludes DISTRICT_LIMITED_USER. */
export const ROLES_CAN_SEE_MY_DISTRICT: UserRolesEnum[] = [
  UserRolesEnum.SUPER_ADMIN,
  UserRolesEnum.PLATFORM_ADMIN,
  UserRolesEnum.DISTRICT_ADMIN,
  UserRolesEnum.DISTRICT_STANDARD_USER,
];

/** Roles allowed to see New Housing (includes Limited — view-only). */
export const ROLES_CAN_SEE_NEW_HOUSING: UserRolesEnum[] = [
  UserRolesEnum.SUPER_ADMIN,
  UserRolesEnum.PLATFORM_ADMIN,
  UserRolesEnum.DISTRICT_ADMIN,
  UserRolesEnum.DISTRICT_STANDARD_USER,
  UserRolesEnum.DISTRICT_LIMITED_USER,
];

/** Roles allowed to create/update/delete schools and related my-district data. */
export const MY_DISTRICT_MUTATION_ROLES: UserRolesEnum[] = [
  UserRolesEnum.SUPER_ADMIN,
  UserRolesEnum.PLATFORM_ADMIN,
  UserRolesEnum.DISTRICT_ADMIN,
];

/**
 * New Housing permissions (view is open to all district roles including Limited):
 * - Projects / occupancy / affected schools: Platform + District Admin + Standard
 * - Default + project generation rates (+ regenerate projections): Platform only
 */
export const NEW_HOUSING_PROJECT_MUTATION_ROLES: UserRolesEnum[] = [
  UserRolesEnum.SUPER_ADMIN,
  UserRolesEnum.PLATFORM_ADMIN,
  UserRolesEnum.DISTRICT_ADMIN,
  UserRolesEnum.DISTRICT_STANDARD_USER,
];

export const NEW_HOUSING_RATES_MUTATION_ROLES: UserRolesEnum[] = [
  UserRolesEnum.SUPER_ADMIN,
  UserRolesEnum.PLATFORM_ADMIN,
];
